// Shared by the review and Mailbox pages.
//
// Display labels from report.py's _CATEGORY_COLORS. Colours themselves live in
// ClassificationReview.css as --cat-<key>, on `.creport` and `.cat-palette`, so
// catColor only resolves inside one of those. Unknown categories fall back to
// --cat-none, so a category added to rules.yaml renders sanely without a
// frontend deploy. The authoritative list is fetched — this is prettification,
// not vocabulary.
export const CATEGORY_LABELS = {
  appointment_request: 'Appointment',
  complaint: 'Complaint',
  warranty_request: 'Warranty',
  membership_renewal: 'Membership',
  billing_inquiry: 'Billing',
  parts_request: 'Parts',
  general_inquiry: 'General',
  spam_marketing: 'Spam / Mktg',
  // Added 2026-08-25 alongside the rules.yaml categories, and asked for by name
  // by DelAir. These replace the 08-13 pair (`business_review`, `permitting`)
  // that was drafted here while the taxonomy question was still open: DelAir
  // did not ask for a business review category, and their word for the other
  // one is "Permit". Without an entry here `catLabel` falls back to the raw
  // key, which is why the dropdown read a lowercase "lead".
  lead: 'Lead',
  compliment: 'Compliment',
  permit: 'Permit',
  // The raw key is the one label the fallback gets visibly wrong: an initialism
  // that has to be uppercase, not the title-cased "Hr" a reader would expect.
  hr: 'HR',
};

export const catLabel = (k) => CATEGORY_LABELS[k] || k || 'Unclassified';
export const catColor = (k) => `var(--cat-${k || 'none'}, var(--cat-none))`;
